module.exports = __webpack_public_path__ + "img/201805-6.a41891cf.jpeg";